exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search-container[data-v-6239f1e5]{display:flex;align-items:center;background-color:#f5f5f5;border-radius:4px;padding:5px;border:1px solid #ddd;margin-bottom:15px}.search-input[data-v-6239f1e5]{border:none;background:transparent;padding:5px;font-size:14px;width:100%;outline:none}.search-icon[data-v-6239f1e5]{color:#888;font-size:16px;margin-right:8px;margin-left:8px}", ""]);

// exports
